import { getRowUiProp } from './rowUiState';

const componentInternalMixin = {
    data() {
      return {
      }
    },

    props: {
        cp : Object,
        parent : Object,
        state: Object
    },

    created() {
    },

    mounted() {      
    },

    updated() {
    },

    methods: {
      getProp(nome, def) {
        // Em lista otimizada, o valor persistido por linha (store reativo, indexado por
        // _id) tem prioridade. Leitura reativa: independe de qual instância do pool do
        // RecycleScroller renderiza a linha, e re-renderiza sozinha quando muda. Resolve
        // o `visible` imperativo ficar preso na instância antiga/estacionada.
        // A identidade da linha vem do componente dono (this.$parent), pois o
        // ClicColInterno não recebe `state`; o cpId vem do próprio cp (mesmo do dono).
        const parent = this.$parent;
        if (parent?.state?.parent?.optimizedList) {
          const persistido = getRowUiProp(
            parent?.state?.parent?.id,
            parent?.state?.row?.index,
            this.cp?.id,
            nome
          );
          if (persistido !== undefined) {
            return persistido;
          }
        }

        return  this.lodash.get( this.state, `row.${nome}`,
                  this.lodash.get( this.$parent, nome,
                    this.lodash.get(this.cp, `props.${nome}`,
                      this.lodash.get(this.$attrs, nome,        
                        def)))
        );
      },
    }
};
 
   export default componentInternalMixin;